import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import SegmentedVideoPlayer, {
  SegmentedVideoPlayerInstance,
  SegmentedVideoPlayerProps,
} from 'components/SegmentedVideoPlayer';
import { mediaSegmentsSelector } from 'redux/modules/embed/selectors';
import { State } from 'redux/types';

export type MediaSegmentVideoPlayerProps = Omit<
  SegmentedVideoPlayerProps,
  'segments'
> & {
  mediaSegmentDataId: string;
};

/**
 * Connects the SegmentedVideoPlayer to our media segment data
 */
const MediaSegmentVideoPlayer = React.forwardRef<
  SegmentedVideoPlayerInstance,
  MediaSegmentVideoPlayerProps
>(({ mediaSegmentDataId, ...props }, ref) => {
  const selector = useMemo(
    () => (state: State) => mediaSegmentsSelector(state, mediaSegmentDataId),
    [mediaSegmentDataId],
  );

  const segments = useSelector(selector);

  return <SegmentedVideoPlayer {...{ segments, ref }} {...props} />;
});

export default MediaSegmentVideoPlayer;
